exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeline-event-quotation__subtitle{margin-top:15px;font-size:12px;font-weight:500;margin-bottom:5px}", ""]);

// exports
